import { enableWebSdk } from "../../functions/index";

(async () => {
	/**
	 * Enable UA web sdk for use with embedded content
	 */
	const { sdk } = await enableWebSdk();

	/**
	 * Track screen view for current page
	 */
	let screenName = location.pathname.replace(/^\/|\/$/g, '');

	if (screenName === '') {
		screenName = 'home';
	}

	await sdk.analytics.trackScreen(screenName);
})();
